import React from "react";
import ObsIframe from "../../../iframe-component/onboarding/ObsIframe";

const Rejected = () => {
  return <ObsIframe path="/tasklist/rejected-task" />;
};

export default React.memo(Rejected);
